import './index.scss'
$("header .nav li").eq(2).addClass("active");
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .mySwiper", {
  direction: 'vertical',
  slidesPerView: 4,
  spaceBetween: 10,
  freeMode: true,
});
var swiper2 = new Swiper(".section1 .mySwiper2", {
  navigation: {
    nextEl: ".section1 .swiper-button-next",
    prevEl: ".section1 .swiper-button-prev",
  }, 
  thumbs: {
    swiper: swiper,
  },
});
$(".right .mySwiper .swiper-slide").click(function () {
  let index = $(this).index();
  swiper2.slideTo(index, 1000, false);
})
$(".swiper-button div").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
})